import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../redux/hooks';
import { fetchPreload } from '../redux/slices/preloadSlice';
import { useUser } from './useUser';

export const usePreload = () => {
    const dispatch = useAppDispatch();
    const { data: preload, loading, error } = useAppSelector((state) => state.preload);

    const user = useUser();

    useEffect(() => {
        const { userKey, userToken } = user;
        if(!userKey || !userToken) { return; }

        // Trigger fetch if no preload data and no active fetch or 4xx error
        if (!preload && !loading && !error) {
            dispatch(fetchPreload());
        }
    }, [dispatch, preload, loading, error, user.userKey, user.userToken]);

    return {
        loading,
        error,
        ...preload,
    };
};